var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeNPageIdStr, makeNPageRangeIdStr, nprojToJson } from "../../../common";
import { downloadPaperFromPaperHub } from "./downloadPaperFromPaperHub";
let _ndp_download_manager_instance = null;
function getFirstKey(sobp) {
    return makeNPageIdStr(Object.assign(Object.assign({}, sobp), { page: undefined }));
}
export default class PaperHubDownloadManager {
    constructor() {
        this._jobs = {};
        this._map = {};
        this.getCachedNprojAndPdf = (sobp) => __awaiter(this, void 0, void 0, function* () {
            // 먼저 다운로드 되고 있는 것이 있는지 확인
            const sobpStr = makeNPageIdStr(sobp);
            if (this._jobs[sobpStr]) {
                return this._jobs[sobpStr];
            }
            // 다운로드 완료된 것이 있는지 확인
            const sobStr = getFirstKey(sobp);
            let found = undefined;
            const sobBooks = this._map[sobStr];
            if (sobBooks) {
                found = Object.entries(sobBooks).find(([key, value]) => {
                    if (value.startSobp.page <= sobp.page && sobp.page < value.startSobp.page + value.numPages) {
                        return true;
                    }
                    return false;
                });
            }
            if (found) {
                return {
                    nproj_url: found[1].nproj_url,
                    pdf_url: found[1].pdf_url,
                    nproj_xml: found[1].nproj_xml,
                };
            }
            const downLoadPromise = downloadPaperFromPaperHub(sobp);
            this._jobs[sobpStr] = downLoadPromise;
            const ret = yield downLoadPromise;
            if (ret && ret.nproj_xml) {
                this.register(ret.nproj_xml, ret.nproj_url, ret.pdf_url);
            }
            delete this._jobs[sobpStr];
            return ret;
        });
        /**
         * 캐시에 등록
         *
         * @param nproj_xml
         * @param nproj_url
         * @param pdf_url
         */
        this.register = (nproj_xml, nproj_url, pdf_url) => {
            const nprojJson = nprojToJson(nproj_xml);
            const startSobp = {
                section: nprojJson.book.section,
                owner: nprojJson.book.owner,
                book: nprojJson.book.book,
                page: nprojJson.book.start_page
            };
            const sobplStr = makeNPageRangeIdStr(startSobp, nprojJson.pdf.numPages);
            const sobStr = getFirstKey(startSobp);
            if (!Object.hasOwnProperty.call(this._map, sobStr)) {
                this._map[sobStr] = {};
            }
            this._map[sobStr][sobplStr] = {
                nproj_xml, nproj_url, pdf_url,
                startSobp, numPages: nprojJson.pdf.numPages
            };
        };
    }
    static getInstance() {
        if (!_ndp_download_manager_instance) {
            _ndp_download_manager_instance = new PaperHubDownloadManager();
        }
        return _ndp_download_manager_instance;
    }
}
//# sourceMappingURL=PaperHubDownloadManager.js.map